import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function PaystackCallback() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const reference = params.get("reference") || params.get("trxref");
  const [state, setState] = useState("verifying"); // verifying | success | failed

  useEffect(() => {
    if (!reference) { setState("failed"); return; }
    api(`/paystack/verify/${reference}`, { auth: false })
      .then((r) => setState(r.status === "success" ? "success" : "failed"))
      .catch(() => setState("failed"));
  }, [reference]);

  return (
    <div className="max-w-md mx-auto py-32 px-6 text-center" data-testid="paystack-callback">
      {state === "verifying" && (
        <>
          <FindoSpinner size={40} className="mx-auto" />
          <p className="mt-4 text-slate-600">{t("pub.verifyingYourPayment")}</p>
        </>
      )}
      {state === "success" && (
        <>
          <div className="mx-auto h-14 w-14 grid place-items-center rounded-full bg-emerald-100 text-emerald-700"><ShieldCheck size={30} /></div>
          <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">{t("pub.paymentConfirmed")}</h1>
          <p className="mt-2 text-slate-600">{t("pub.paymentConfirmedDesc")}</p>
          <Link to="/" className="mt-6 inline-flex rounded-xl bg-findo-indigo text-white font-semibold px-6 py-3" data-testid="paystack-home-link">{t("pub.backHome")}</Link>
        </>
      )}
      {state === "failed" && (
        <>
          <div className="mx-auto h-14 w-14 grid place-items-center rounded-full bg-rose-100 text-rose-600"><XCircle size={30} /></div>
          <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">{t("pub.paymentNotConfirmed")}</h1>
          <p className="mt-2 text-slate-600">{t("pub.paymentNotConfirmedDesc")}</p>
        </>
      )}
    </div>
  );
}
